<template>
  <div class="cmp-wrapper">
    <basic-container>
      <tab-table></tab-table>
    </basic-container>
  </div>
</template>


<script>
import TabTable from "./../../../blocks/mc-tab-table/index.js";

export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {
    TabTable
  }
};
</script>


<style lang="scss" scoped>
.cmp-wrapper {
}
</style>
